import { useWebAudioPlayer, WebAudioSource } from "core/hooks/useWebAudioPlayer/useWebAudioPlayer";
import { AudioPlayerControlBar } from "../AudioPlayerControlBar/AudioPlayerControlBar";

export type AudioPlayerProps = {
  link: string;
};

export const WebAudioPlayer = ({ link }: AudioPlayerProps) => {
  const player = useWebAudioPlayer();

  return (
    <>
      <WebAudioSource src={link} player={player} />

      <div className="pt-5">
        <AudioPlayerControlBar
          disabled={!player.isInitialised}
          position={player.duration > 0 ? player.playTime / player.duration : 0}
          duration={player.duration}
          isPlaying={player.isPlaying}
          play={player.play}
          pause={player.pause}
          onSeekMouseDown={player.onSeekMouseDown}
          onSeekMouseUp={player.onSeekMouseUp}
          onSeekChange={player.onSeekChange}
        />
      </div>
    </>
  );
};
